/*
 * minimal-product-upsell.js
 * Cards de upsell del PDP minimal: clic agrega el producto al carrito por AJAX
 * SIN abrir el cart-drawer, marca la card como "agregada" y refresca el contador
 * del header. Pre-marca las cards cuyo producto ya está en el carrito.
 * Aislado, sin dependencias. No toca ninguna otra sección.
 */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function refreshBubble() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d['cart-icon-bubble']) return;
        var el = document.getElementById('cart-icon-bubble');
        if (el) el.innerHTML = d['cart-icon-bubble'];
      })
      .catch(function () {});
  }

  function init() {
    var cards = document.querySelectorAll('[data-mp-upsell-card]');
    if (!cards.length) return;

    // Pre-marcar cards cuyo producto ya está en el carrito
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var ids = {};
        cart.items.forEach(function (it) { ids[String(it.variant_id || it.id)] = true; });
        cards.forEach(function (card) {
          if (ids[card.getAttribute('data-variant-id')]) card.classList.add('is-added');
        });
      })
      .catch(function () {});

    document.querySelectorAll('[data-mp-upsell-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-mp-upsell-card]');
        if (!card) return;
        if (btn.hasAttribute('disabled') || card.classList.contains('is-loading')) return;
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        var adding = !card.classList.contains('is-added');
        card.classList.add('is-loading');
        // Agregar: /cart/add.js  ·  Quitar: /cart/change.js con quantity 0
        var req = adding
          ? fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: id, quantity: 1 })
            })
          : fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: id, quantity: 0 })
            });
        req
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            card.classList.remove('is-loading');
            card.classList.toggle('is-added', adding);
            refreshBubble();
          })
          .catch(function () { card.classList.remove('is-loading'); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
